import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import styles from "./tryus.module.scss"
import Img from "gatsby-image"

function apropos({ description, lang, meta, keywords, title }) {
  const { site, taxi, money, com } = useStaticQuery(
    graphql`
      query {
        site: site {
          siteMetadata {
            websiteConfig {
              about {
                title
                subtitle
                content
              }
            }
          }
        }
      }
    `
  )

  return (
    <div className={`row ${styles.main}`}>
      <div className="col-lg-12">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 mb-5 p-0">
              <h2>Essayez nous</h2>
              <div className="sBar" />
              <span className="welcome">
                La publicité accéssible, et efficace
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <h3>Service</h3>
              <p>
                Le TiTAN Media permet aux annonceurs de communiquer au plus près
                de leurs cibles en apportant de la satisfaction immédiate et
                au-delà, par l’intermédiaire d’un objet simple, utile et
                efficace qu’est la Tablette Tactile dans les Véhicules.
              </p>
            </div>
            <div className="col-lg-6">
              <h3>Visible</h3>
              <p>
                Le TiTAN Media c’est une diffusion dans les taxis, les
                Compagnies Privées, et bientôt dans les trains, les bus, les
                cars, les voitures de location.
              </p>
            </div>
            <div className="col-lg-6">
              <h3>Puissant</h3>
              <p>
                L’ensemble du réseau de diffusion "Le TiTAN Media", permet de
                toucher plusieurs millions de personnes par an, avec une
                visibilité immédiate en ``one to one``
              </p>
            </div>
            <div className="col-lg-6">
              <h3>Innovant</h3>
              <p>
                Le TiTAN Media est la nouvelle façon de faire ses compagnes
                publicitaires ! Une campagne de notoriété (OOH) et une campagne
                Go To Store (DOOH) .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default apropos
